import { render, staticRenderFns } from "./InputTel.vue?vue&type=template&id=6b0da1ec&scoped=true&"
import script from "./InputTel.vue?vue&type=script&lang=js&"
export * from "./InputTel.vue?vue&type=script&lang=js&"
import style0 from "./InputTel.vue?vue&type=style&index=0&id=6b0da1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0da1ec",
  null
  
)

export default component.exports